import { Link } from "react-router-dom";
import { Globe2, MessageCircle, LayoutDashboard, Palette, ArrowRight } from "lucide-react";

const FEATURES = [
  { icon: Globe2, title: "A website for every school", text: "Each preschool gets its own address, branding, photos, programmes and fees." },
  { icon: MessageCircle, title: "AI admission assistant", text: "Answers fee questions and collects parent details, day and night." },
  { icon: LayoutDashboard, title: "Leads sorted for you", text: "Every enquiry lands in the right school's dashboard, marked Hot, Warm or Cold." },
  { icon: Palette, title: "Fully white-label", text: "Colours, fonts, logo and banners set per school from one console." },
];

export default function PlatformHome() {
  return (
    <div className="min-h-screen bg-[#FAFAF9]" data-testid="platform-home">
      <header className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <span className="font-display font-semibold text-xl" data-testid="platform-brand">Preschool<span className="text-brand">Platform</span></span>
        <Link to="/admin" className="px-4 py-2 rounded-full btn-brand text-sm font-semibold" data-testid="platform-signin-button">Admin sign in</Link>
      </header>
      <section className="bg-brand-soft dots-bg">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-24 max-w-3xl">
          <p className="rise text-sm font-semibold text-brand uppercase tracking-wider">For preschools, nurseries &amp; daycares across India</p>
          <h1 className="rise rise-1 mt-3 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]" data-testid="platform-hero-title">
            Admissions websites that bring parents to your door
          </h1>
          <p className="rise rise-2 mt-5 text-base sm:text-lg text-stone-600 max-w-xl">
            One platform, many schools. Launch a branded site with an AI enquiry assistant for every preschool you run.
          </p>
          <Link to="/admin" className="rise rise-3 mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full btn-brand font-semibold" data-testid="platform-hero-cta">
            Open admin console <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-20 grid sm:grid-cols-2 gap-5">
        {FEATURES.map(({ icon: Icon, title, text }) => (
          <div key={title} className="bg-white rounded-3xl border p-6 transition-transform duration-300 hover:-translate-y-1">
            <div className="w-11 h-11 rounded-2xl bg-brand-soft text-brand flex items-center justify-center mb-5"><Icon className="w-5 h-5" /></div>
            <h3 className="text-xl font-semibold">{title}</h3>
            <p className="text-sm text-stone-600 mt-2">{text}</p>
          </div>
        ))}
      </section>
      <footer className="text-center text-xs text-stone-400 pb-10">© {new Date().getFullYear()} Preschool Platform</footer>
    </div>
  );
}
